export default "__VITE_ASSET__AiQRLI0g__";